module.exports = __webpack_public_path__ + "img/Categories.b39448af.jpg";